import Storage from '@/lib/storage';
// const Cookies = new Storage('cookie');
const ls = new Storage('localStorage');

const state = {
    message: {}, // 系统消息
    currentUser: {}, // 当前用户信息
    loading: false, // 加载中
    brand: {
        ver: ls.getItem('brandVer'), // 品牌版本号
        publishBrand: ls.getItem('publishBrand') // 品牌信息
    },
    // 账号互顶
    topAccountError: {
        visible: false, // 弹窗是否显示
        data: {}, // 互顶时间
        desc: ''
    },
    memberUser: {},
    memberUserV3: {},
    brandFactory: {},
    pagePermission: ls.getItem('pagePermission'), // 页面权限key
    improveVisible: false,
    unreadMessage: {
        like: 0, 
        message: 0
    },
    breadCrumbList: [],
};
export default state;
